export default "/images/1e606f40438c9a847260f927d8e49e60.avif";